/* ZynaroHealth theme — AJAX side cart, free-shipping bar, variant price, nav */
(function () {
  "use strict";

  var drawer = document.getElementById("CartDrawer");
  var THRESHOLD = drawer ? parseInt(drawer.getAttribute("data-threshold"), 10) || 50000 : 50000;

  /* ---- money (ZAR) ---- */
  function money(cents) {
    var v = (Math.abs(cents) / 100).toFixed(2).split(".");
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "R " + v.join(".");
  }

  /* ---- drawer open/close ---- */
  function openDrawer() { document.body.classList.add("drawer-open"); }
  function closeDrawer() { document.body.classList.remove("drawer-open"); }

  /* ---- render cart into drawer ---- */
  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = "(" + cart.item_count + ")";
    });
    if (!drawer) return;

    var bar = drawer.querySelector("[data-ship-bar]");
    var msg = drawer.querySelector("[data-ship-msg]");
    var pct = THRESHOLD > 0 ? Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)) : 100;
    if (bar) bar.style.width = pct + "%";
    if (msg) {
      msg.innerHTML = cart.total_price >= THRESHOLD
        ? "🎉 Congrats! You get <strong>FREE shipping!</strong>"
        : "You're <strong>" + money(THRESHOLD - cart.total_price) + "</strong> away from <strong>FREE shipping</strong>";
    }

    var itemsEl = drawer.querySelector("[data-cart-items]");
    if (itemsEl) {
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.<br><br><a class="btn btn-primary" href="/collections/all">Start shopping</a></p>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var variant = (item.variant_title && item.variant_title.indexOf("Default") === -1)
            ? '<div class="cd-variant">' + item.variant_title + "</div>" : "";
          var img = item.image
            ? '<img src="' + item.image + '" alt="" loading="lazy">' : "";
          return (
            '<div class="cd-item" data-key="' + item.key + '">' +
              '<div class="cd-img">' + img + "</div>" +
              '<div class="cd-info">' +
                '<a href="' + item.url + '">' + item.product_title + "</a>" + variant +
                '<div class="cd-price">' + money(item.final_price) + " each</div>" +
                '<div class="cd-qty">' +
                  '<button type="button" data-dec aria-label="Decrease">&minus;</button>' +
                  "<span>" + item.quantity + "</span>" +
                  '<button type="button" data-inc aria-label="Increase">+</button>' +
                  '<button type="button" class="cd-remove" data-remove>Remove</button>' +
                "</div>" +
              "</div>" +
              '<div class="cd-line">' + money(item.final_line_price) + "</div>" +
            "</div>"
          );
        }).join("");
      }
    }

    var sub = drawer.querySelector("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
    drawer.classList.toggle("is-empty", cart.item_count === 0);
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function refresh(open) {
    return getCart().then(function (c) { renderCart(c); if (open) openDrawer(); return c; });
  }

  /* ---- intercept Add to cart ---- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form.matches && form.matches('form[action*="/cart/add"]'))) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
    fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { return refresh(true); })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---- qty change / remove inside drawer ---- */
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target.hasAttribute("data-close")) { closeDrawer(); return; }
      var itemEl = e.target.closest(".cd-item");
      if (!itemEl) return;
      var key = itemEl.getAttribute("data-key");
      var qty = parseInt(itemEl.querySelector(".cd-qty span").textContent, 10);
      var next = qty;
      if (e.target.hasAttribute("data-inc")) next = qty + 1;
      else if (e.target.hasAttribute("data-dec")) next = qty - 1;
      else if (e.target.hasAttribute("data-remove")) next = 0;
      else return;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  /* ---- open drawer from header cart, close on overlay / esc ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-cart-toggle]");
    if (toggle) { e.preventDefault(); refresh(true); return; }
    if (e.target.id === "CartOverlay" || e.target.hasAttribute("data-close")) closeDrawer();
    if (e.target.closest(".site-nav a")) document.body.classList.remove("nav-open");
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---- product page: sync price with variant ---- */
  var vs = document.querySelector("[data-variant-select]");
  var pe = document.querySelector("[data-current-price]");
  if (vs && pe) {
    vs.addEventListener("change", function () {
      var o = vs.options[vs.selectedIndex];
      if (o && o.dataset.price) pe.textContent = o.dataset.price;
    });
  }

  /* ---- reveal-on-scroll animations ---- */
  function initReveal() {
    var els = document.querySelectorAll(
      ".hero-copy, .hero-media, .trust, .multirow .mr-row, .section-head, .product-card, .collection-row-head, .newsletter .container"
    );
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!("IntersectionObserver" in window) || reduce) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { el.classList.add("reveal"); io.observe(el); });
  }

  /* ---- header lift on scroll ---- */
  function onScroll() { document.body.classList.toggle("scrolled", window.scrollY > 20); }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  initReveal();

  /* ---- prime drawer contents on load ---- */
  refresh(false);
})();
